<template>
  <v-container class="login-modal main-content">
    <v-layout align-center justify-center column class="wide-screen">
      <v-flex class="welcome-logo">
        <div class="logo-wrapper">
          <logo></logo>
        </div>
      </v-flex>
      <p
        v-if="$store.state.authError && !$store.state.overlay"
        class="error msg-error"
        data-cy="error">
        {{ $store.state.authError }}
      </p>
      <v-flex class="login-form">
        <v-form v-model="valid">
          <v-text-field
            dark
            solo-inverted
            :validate-on-blur="true"
            clearable
            prepend-inner-icon="fas fa-user"
            v-model="email"
            :rules="emailRules"
            label="Email Address"
            autocomplete="username"
            data-cy="login-email"
            required></v-text-field>
          <v-text-field
            @keyup.enter.native="login()"
            :append-icon="show ? 'fa fa-eye' : 'fa fa-eye-slash'"
            @click:append="show = !show"
            dark
            solo-inverted
            :validate-on-blur="true"
            prepend-inner-icon="fas fa-lock"
            v-model="password"
            :type="show ? 'text' : 'password'"
            :rules="passwordRules"
            label="Password"
            required
            clearable
            autocomplete="current-password"
            data-cy="login-password"></v-text-field>
          <v-btn data-cy="login-btn" dark rounded block @click="login()">
            Login
          </v-btn>

          <v-layout wrap justify-space-between class="helper-links">
            <v-flex>
              <router-link to="/create-account">Create Account</router-link>
            </v-flex>
            <v-flex>
              <router-link :to="{ name: 'Reset Password' }">
                Reset Password
              </router-link>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Logo from "../../shared/common/Logo"

export default {
  components: { Logo },
  data() {
    return {
      dialog: true,
      valid: false,
      show: false,
      email: "",
      emailRules: [
        (v) => !!v || "Email Address is required",
        (v) => /.+@.+/.test(v) || "Email Address must be valid",
      ],
      password: "",
      passwordRules: [(v) => !!v || "Password is required"],
    }
  },

  mounted() {
    // this.$cookie.delete("disabled-animation");
    // this.$cookie.delete("circular-animation");
    this.$store.commit("setAuthError", "")
  },

  methods: {
    login() {
      this.$store.commit("setAuthError", "")
      this.$store.dispatch("login", {
        email: String(this.email).toLocaleLowerCase().trim(),
        password: String(this.password).trim(),
      })
    },
  },
}
</script>

<style scoped lang="sass">
@import '@/assets/sass/globals.sass'
.login-form
  min-width: 304px
// .login-form > p, .login-form > form
  // max-width: 296px

.login-modal
  background-image: $bg-green-gradient

.welcome-logo
  display: flex
  align-items: center
  justify-content: center
  width: 180px
  margin-top: 25%
  padding-bottom: 10%

  .logo-wrapper
    width: 162px
    height: 162px

.msg-error
  color: white
  padding: 10px
  border-radius: 10px
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)

.v-btn
  background-color: $bright-green !important
  color: $white
  height: 45px

.helper-links > *
  flex: initial

  & a
    margin: 3em 0 0 0
    // padding: 1em 1.5em
    display: inline-block
    text-decoration: none
    font-weight: 600
    color: $black
    white-space: nowrap
    text-align: center

@media only screen and (max-width: $stacked-buttons)
  .helper-links
    justify-content: space-around
</style>
